import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ChannelItemEmail } from '../sic-lib/types/ChannelItem';

export interface ContactState {
    emailThreadDrawer: ChannelItemEmail | undefined;
}

const initialState: ContactState = {
    emailThreadDrawer: undefined,
};

const contactSlice = createSlice({
    name: 'contact',
    initialState,
    reducers: {
        setEmailThreadDrawer: (
            state,
            action: PayloadAction<{ channelItem: ChannelItemEmail | undefined }>,
        ) => {
            const { channelItem } = action.payload;
            state.emailThreadDrawer = channelItem;
        },
    },
});

export const { setEmailThreadDrawer } = contactSlice.actions;

export default contactSlice.reducer;
